import Vue from "vue";
import Vuex from "vuex";
import Buefy from "buefy";

Vue.use(Buefy);
Vue.use(Vuex);

import SearchLister from "./components/MarketSearch/SearchLister.vue";
import SearchListerHeader from "./components/MarketSearch/SearchListerHeader.vue";

new Vue({
	el: "#market-search",
	store: window.app.store,
	data() {
		return {};
	},
	components: { SearchLister, SearchListerHeader },
	mounted() {},
	methods: {},
});
